import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcLogoutSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 3.25C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H7C6.30964 4.75 5.75 5.30964 5.75 6V18C5.75 18.6904 6.30964 19.25 7 19.25H15C15.4142 19.25 15.75 19.5858 15.75 20C15.75 20.4142 15.4142 20.75 15 20.75H7C5.48122 20.75 4.25 19.5188 4.25 18V6C4.25 4.48122 5.48122 3.25 7 3.25H15ZM16.5303 8.46967C16.2374 8.17678 15.7626 8.17678 15.4697 8.46967C15.1768 8.76256 15.1768 9.23744 15.4697 9.53033L17.1893 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H17.1893L15.4697 14.4697C15.1768 14.7626 15.1768 15.2374 15.4697 15.5303C15.7626 15.8232 16.2374 15.8232 16.5303 15.5303L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L16.5303 8.46967Z",
		fill: "inherit"
	})
});
export default SvgIcLogoutSmallOl;
